var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.details)?_c('div',[_c('Canvas',{attrs:{"json":_vm.initial_json,"title":_vm.details.name + ' # ' + _vm.details.id},on:{"save":_vm.onSave}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }